const scoreStyle = {
    low: "rgb(216, 0, 0)",
    medium: "rgb(219, 143, 0)",
    high: "rgb(0, 156, 0)",
}

function getScoreColor(score) {
    if (score === null) return;
    return score < 500 ? scoreStyle["low"] :
    score < 700 ? scoreStyle["medium"] : scoreStyle["high"]
}

export { scoreStyle, getScoreColor }